module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_G170092.a005948f.png";